import { Dialog, DialogContent } from "@mui/material"
import { PaperArrastavel } from "app/components/dialog-arrastavel/PaperArrastavel"
import React from "react"
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { SenhaVendedorContainerDialog } from "../senha-vendedor/SenhaVendedorContainerDialog"
import { AlterarSenhaVendedorContainer } from "./AlterarSenhaVendedorContainer"

export const AlterarSenhaVendedorContainerDialog = () => {
    return <>
        <Dialog open={true} fullScreen PaperComponent={PaperArrastavel}>
            <DialogContent>
                <div className="_flex _justify-center _w-full _mt-24">
                    <AlterarSenhaVendedorContainer
                        onCancelar={() => {
                            removerComponenteReact("alterar-senha-vendedor-container-dialog")
                            renderizarComponentReact(SenhaVendedorContainerDialog, "senha-vendedor-container-dialog", false)
                        }}
                        onSenhaAlterada={() => {
                            removerComponenteReact("alterar-senha-vendedor-container-dialog")
                            renderizarComponentReact(SenhaVendedorContainerDialog, "senha-vendedor-container-dialog", false)
                        }}
                        />
                </div>
            </DialogContent>
        </Dialog>
    </>
}

(window as any).AlterarSenhaVendedorContainerDialog = AlterarSenhaVendedorContainerDialog